export enum PageRoutes {
  Home = "/",
  LoginQR = "/login-qr",
  Game = "/game",
  Explore = "/explore",
  Search = "/search",
  MyGames = "/my-games",
  Settings = "/settings",
  General = "/settings/general",
  ProfileInfo = "/settings/account-info",
  Subscription = "/settings/subscription",
  StreamingProfile = "/settings/streaming-profile",
  Exit = "/settings/exit",
  Activate = "/activate",
  Paywall = "/subscribe",
  Payment = "/payment",
  EssentialPass = "/essential-pass",
  InstallGame = "/install-game",
  GamePlay = "/play",
  Landing = "/landing",
  Onboarding = "/onboarding",
  SetProfile = "/set-profile",
  Privacy = "/privacy-policy",
  LegalInformation = "/legal-information",
  OpenSource = "/open-source",
  Tnc = "/tnc",
  Support = "/support",
  Tv = "/tv",
  ErrorNetwork = "/error-network",
}

/**
 * Routes that only exist when the subscription flow is enabled. Navigations to
 * them are swallowed and replaced by the "Subscription Required" popup when
 * VITE_DISABLE_SUBSCRIPTION is on.
 */
export const SUBSCRIPTION_PATHS: string[] = [
  PageRoutes.Paywall,
  PageRoutes.Payment,
  PageRoutes.Subscription,
];
